module.exports = __webpack_public_path__ + "static/media/leadership-image4.d86fa74a.png";